import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { newsAPI } from '../services/api'
import LoadingSpinner from '../components/LoadingSpinner'
import GalleryContent from '../components/GalleryContent'
import './NewsPage.css'

function formatDate(d) {
  if (!d) return ''
  try {
    return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
  } catch {
    return d
  }
}

function NewsPage() {
  const { newsId } = useParams()
  const navigate = useNavigate()
  const [items, setItems] = useState([])
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let active = true
    ;(async () => {
      // Yield a microtask so loading/error resets aren't set synchronously
      // within the effect body (avoids a cascading render); behaviour is
      // unchanged.
      await Promise.resolve()
      if (!active) return
      setLoading(true)
      setError(null)
      try {
        if (newsId) {
          const n = await newsAPI.getById(newsId)
          if (active) setSelected(n)
        } else {
          const l = await newsAPI.list()
          if (active) setItems(l)
        }
      } catch (e) {
        if (active) setError(e.message)
      } finally {
        if (active) setLoading(false)
      }
    })()
    return () => { active = false }
  }, [newsId])

  if (loading) {
    return <div className="page-container"><LoadingSpinner size="large" message="Loading news..." /></div>
  }

  // Detail view
  if (newsId) {
    if (error || !selected) {
      return (
        <div className="page-container">
          <div className="page-header"><h1>News</h1></div>
          <div className="news-detail">
            <p>Sorry, that article could not be found.</p>
            <button className="btn btn-secondary" onClick={() => navigate('/news')}>Back to news</button>
          </div>
        </div>
      )
    }
    return (
      <div className="page-container">
        <div className="page-header">
          <button className="btn btn-secondary" onClick={() => navigate('/news')}>&larr; All news</button>
          <h1>{selected.title}</h1>
          {selected.created_date && <p className="news-date">{formatDate(selected.created_date)}</p>}
        </div>
        <div className="news-detail">
          <article>
            {selected.introtext && <GalleryContent content={selected.introtext} />}
            {selected.content && selected.content !== selected.introtext && (
              <GalleryContent content={selected.content} />
            )}
          </article>
        </div>
      </div>
    )
  }

  // List view
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>News</h1>
        <p>Club news, events and repacks</p>
      </div>
      <div className="news-list">
        {error && <p className="news-error">Could not load news: {error}</p>}
        {!error && items.length === 0 && <p>No news articles yet.</p>}
        {items.map((n) => (
          <button key={n.news_id} className="news-card" onClick={() => navigate(`/news/${n.news_id}`)}>
            <h2>{n.title}</h2>
            {n.created_date && <span className="news-card-date">{formatDate(n.created_date)}</span>}
            {n.excerpt && <p className="news-card-excerpt">{n.excerpt}</p>}
          </button>
        ))}
      </div>
    </div>
  )
}

export default NewsPage
